import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight';
// native components
import LeadersTwoColumnContent from '../leadersTwoColumnContent';
// images
import profilePicWebp from './images/jeff-sippel.webp';
// styles
import {
  LinkedinStyledSocialIcon,
  LinkStyledBio,
} from '../../styles';

export default () => {
  const name = 'Jeff Sippel';
  const nameString = 'jeff-sippel';
  const title = 'Chief Strategy Officer';

  return (
    <LeadersTwoColumnContent
      id='leaders-chief-strategy-officer'
      header={name}
      title={title}
      isExecutiveVicePresident
      isLastItem
      content={(
        <>
          <Typography
            itemprop='description'
            nextelement='link'>
            Jeff oversees the organization focused on defining our enterprise strategy&#8212;inclusive of the client, field and planning experience&#8212;to drive Northwestern Mutual&#39;s differentiated value proposition and long&#45;term company growth.
          </Typography>
          <LinkStyledBio
            id={`leaders-section-${nameString}-bio-pdf-link`}
            linkUrl='/assets/pdf/leaders/sippel-jeff-bio.pdf'
            ariaLabel={`Download the bio pdf for ${name}`}
            isInternalPdf
            endAdornment={CaratRight}
            endAdornmentStylesReset
            variant='buttonLinkTertiary'>
            See full bio
          </LinkStyledBio>
          <Row>
            <Col nested>
              <Link
                id={`leaders-section-${nameString}-linkedin-social-link`}
                variant='primary'
                linkUrl='https://www.linkedin.com/in/jsippel/'
                ariaLabel={`${name} Linkedin profile`}
                isOutgoingLink>
                <LinkedinStyledSocialIcon />
              </Link>
            </Col>
          </Row>
        </>
      )}
      image={profilePicWebp}
      imageAlt={`Northwestern Mutual Executive Vice President and ${title} ${name}.`}
      reversed={false}
    />
  );
};
